import classnames from 'classnames';
import type { IconColor } from '../../icon/Icon';
import { Icon } from '../../icon/Icon';
import * as styles from './IconButton.module.scss';

interface IIconButtonProps {
    buttonClassName?: string;
    className?: string;
    color: IconColor;
    disabled?: boolean;
    icon: string;
    iconClassName?: string;
    inputType?: 'submit' | 'button';
    onClick: () => void;
}

export function IconButton(props: IIconButtonProps) {
    const className = styles.iconButton;
    props.inputType = props.inputType ?? 'button';

    return (
        <button
            className={classnames(className, props.buttonClassName || '')}
            disabled={props.disabled}
            onClick={props.onClick}
            type={props.inputType}
        >
            <Icon
                className={props.iconClassName}
                color={props.color}
                icon={props.icon}
                size="small"
            />
        </button>
    );
}
